import ChannelCheckbox from './checkbox';
import {
    FILTER_KEYS,
    FILTER_ITEM_CLASS,
    SUB_CHANNEL_FILTER_LIST,
} from '@consts';

import FilterMixin from '../mixin';
import { mapGetters } from 'vuex';
import { isValueExist } from '@/utils/utils';

const { CHANNEL } = FILTER_KEYS;

export default {
    name: 'ChannelFilter',
    mixins: [FilterMixin],
    props: {
        handleSubmit: {
            type: Function,
        },
        selectedOption: {
            type: Array,
        },
        enableBlock: { type: Boolean, default: true },
        filterVisible: {
            type: Boolean,
            default: false,
        },
        isNewFilterUI: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        tagList: {
            handler() {
                const { getSelectedOption } = this;

                const selectedTags = getSelectedOption(CHANNEL);

                this.selectedItems = R.compose(
                    R.filter(Boolean),
                    R.pluck('filterBy')
                )(selectedTags);
            },
        },
    },
    data() {
        return {
            selectedItems: [],
            values: {
                type: CHANNEL,
                value: '',
            },
        };
    },
    computed: {
        ...mapGetters('newDashboard', ['adAccountChannels']),

        // channelList: R.compose(
        //     R.without(['adverity']),
        //     R.propOr([], 'adAccountChannels')
        // ),

        channelList() {
            const { adAccountChannels, isLegacyChannelFilter } = this;

            const updatedChannelList = R.compose(
                R.without(['adverity']),
                R.when(
                    R.includes('google'),
                    R.compose(
                        R.without('google'),
                        (index) =>
                            R.insertAll(
                                index,
                                SUB_CHANNEL_FILTER_LIST,
                                adAccountChannels
                            ),
                        R.findIndex(R.equals('google'))
                    )
                )
            )(adAccountChannels);

            const legacyChannelList = R.compose(R.without(['adverity']))(
                adAccountChannels
            );

            return isLegacyChannelFilter
                ? legacyChannelList
                : updatedChannelList;
        },
    },
    methods: {
        emitFilter() {
            const { values, currentState: state } = this;
            const { type, value } = values;

            const updatedValue = { type, filterBy: value };

            this.$emit('update', { value: updatedValue, state });
        },
        renderChannelOptions() {
            const {
                values,
                filterByKeyword,
                isAutoComplete,
                prefix,
                highlightMatchingText,
                selectedItems: _selectedItems,
                channelList,
                enableBlock,
                selectedOption,
                normalizeText,
                handleSubmit,
                isNewFilterUI,
            } = this;
            const { type } = values;

            const selectedItems = isValueExist(selectedOption)
                ? selectedOption
                : _selectedItems;

            const renderer = (v) => {
                const option = this.$t(`FILTERS.${type}_option_${v}`);

                return (
                    <li
                        class={FILTER_ITEM_CLASS}
                        onClick={() =>
                            (this.values = R.assoc('value', v, values))
                        }
                    >
                        <p
                            domProps={{
                                innerHTML: highlightMatchingText(
                                    `${prefix}${option}`
                                ),
                            }}
                        />
                    </li>
                );
            };

            return isAutoComplete ? (
                filterByKeyword(channelList, renderer)
            ) : (
                <ChannelCheckbox
                    enableBlock={enableBlock}
                    options={channelList}
                    onSubmit={(channels) => {
                        if (channels.length) {
                            this.values = R.assoc('value', channels, values);
                        }

                        handleSubmit && handleSubmit(this.values);
                    }}
                    selectedItems={selectedItems}
                    normalizeText={normalizeText}
                    isNewFilterUI={isNewFilterUI}
                />
            );
        },
    },
    render() {
        const {
            shouldHideFilter,
            filterVisible,
            getCommonHeader,
            renderChannelOptions,
        } = this;

        if (shouldHideFilter && !filterVisible) return null;

        return (
            <div>
                {getCommonHeader()}
                {renderChannelOptions()}
            </div>
        );
    },
};
